
























































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import vSelect from 'vue-select';
import { CheckIcon, CircleIcon, DiscIcon, InfoIcon, UserIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { IRole, IUser, UpdateAccountSettingsDto, UserStatus } from 'admiral-core';
import Avatar from '@/components/common/Avatar.vue';
import { Util } from '@/utils/Util';
import AButton from '@/components/common/AButton.vue';
import { AuthAction } from '@/store/AuthModule';
import { AuthApi } from '@/services/AuthApi';

@Component({
  components: { Avatar, vSelect, CircleIcon, InfoIcon, DiscIcon, UserIcon, AButton, CheckIcon },
})
export default class AccountSettings extends mixins(BaseMixin) {
  @Prop({ required: true, type: Object })
  selectedUser!: IUser;

  isLoading = false;
  isDone = false;
  error = '';
  success = '';
  model: Partial<IUser> = {};
  profilePictureFile = '';
  emailChanged = false;
  confirmationLinkSent = false;

  role: IRole | null = null;
  status: UserStatus | null = null;

  async mounted() {
    this.model = {
      ...this.selectedUser,
    };
  }

  handleResetForm(evt: Event) {
    evt.preventDefault();
  }
  @Watch('model.email', { deep: true, immediate: true })
  handleChange() {
    this.emailChanged = this.selectedUser.email !== this.model.email;
  }
  async handleResendConfirmationEmail() {
    (await AuthApi.sendConfirmationEmail(this.selectedUser.email)).data;
    this.confirmationLinkSent = true;
  }
  async handleSubmit(evt: Event) {
    evt.preventDefault();
    this.success = '';
    this.error = '';

    try {
      this.isLoading = true;
      // await Util.wait(500);

      await this.$store.dispatch(`AuthModule/${AuthAction.UpdateAccountSettings}`, {
        user: this.model,
        firstname: this.model.firstname,
        lastname: this.model.lastname,
        moduleKbvBusinessPlanPlus: this.model.moduleKbvBusinessPlanPlus,
        moduleKbvWinnersClub: this.model.moduleKbvWinnersClub,
        moduleKbvFallAds: this.model.moduleKbvFallAds,
        reminderDaily: this.model.reminderDaily,
        reminderDailyDamage: this.model.reminderDailyDamage,
      } as UpdateAccountSettingsDto);
      this.isLoading = false;
      this.success = 'Erfolgreich gespeichert.';
    } catch (e) {
      this.error = 'Etwas ist schiefgelaufen.';
      this.isLoading = false;

      this.$toastr.e(
        'Beim Speichern ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      throw e;
    }
  }
  async handleDeleteProfilePicture(evt: Event) {
    evt.preventDefault();
    try {
      await this.$store.dispatch(`AuthModule/${AuthAction.RemoveProfilePicture}`, this.model.id);
    } catch (e) {
      this.$toastr.e(
        'Beim Löschen des Bildes ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      throw e;
    }
  }
  async handleFileUpload() {
    this.profilePictureFile = (this.$refs.file as HTMLFormElement).files[0];
    const formData = new FormData();

    /*
        Add the form data we need to submit
    */
    formData.append('images', this.profilePictureFile);
    try {
      const hadProfilePicture = !!this.model.profilePictureId;
      await this.$store.dispatch(`AuthModule/${AuthAction.SetProfilePicture}`, {
        user: this.model,
        formData: formData,
      });

      if (hadProfilePicture) {
        window.location.reload();
      }
    } catch (e) {
      this.$toastr.e(
        'Beim Hochladen des Bildes ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      throw e;
    }
    (this.$refs.file as HTMLFormElement).value = '';
  }

  roleLabel(role: IRole) {
    return Util.formatUserRoleName(role);
  }

  statusLabel(status: UserStatus) {
    return Util.formatUserStatus(status);
  }
  openFileUpload() {
    (this.$refs.file as HTMLFormElement).click();
  }
}
